import type { WebsitePageSearchType } from "pro-features/components/AutocompleteWebsites/types";
import { getRecentParams } from "app/pages/digital-suite/home-page/components/ActivationWizard/ActivationWizardUtils";
import { proNavigator } from "single-spa/react-app/ProNavigator";

interface TransitionParams {
    keyValue: string;
    searchType?: WebsitePageSearchType;
    stateKey?: string;
    selectedPageTab?: string;
}

/**
 * Builds transition params for navigating to a keyword detail page.
 *
 * @param params an object containing the parameters for the transition
 * @param params.keyValue the value of the keyword to navigate to
 * @param params.searchType the search type of the keyword to navigate to, defaults to "exact"
 * @param params.stateKey the stateKey of the keyword detail page, defaults to "organicsearch_websites_v2_traffic_keywords"
 * @param params.selectedPageTab the selected page tab, defaults to "Paid"
 * @returns an object with the transition params
 */
export function getFinalTransitionParamsToKeywordDetailPage({
    keyValue,
    searchType = "exact",
    stateKey = "organicsearch_websites_v2_traffic_keywords",
    selectedPageTab = "Total",
}: TransitionParams): Record<string, string> {
    const defaultParams = proNavigator.getState(stateKey).defaultQueryParams;
    const recentParams = Object.fromEntries(Object.entries(getRecentParams() ?? {}).filter(([key]) => key !== "key"));

    return {
        ...defaultParams,
        ...recentParams,
        key: keyValue,
        selectedPageTab,
        pageFilter: JSON.stringify([{ url: keyValue, searchType }]),
    };
}
